import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import './ro-input.scss';

@Component
export default class ROInput extends Vue {
  @Prop() value;
  @Prop({ required: true }) label;
  @Prop() changeLabel;

  get changeText() {
    if (this.changeLabel) {
      return this.changeLabel;
    } else {
      return `Change ${this.label}`
    }
  }

  render(createElement) {
    return <div class="dt-readonly-form">
      <div class="dt-readonly-form--input">
        <div class="dt-readonly-form--label"> {this.label} </div>
        <div class="dt-readonly-form--control">
          {this.value && <div class="dt-readonly-form--value">
            { this.value }
          </div>}
          <div class="dt-readonly-form--options">
            <div class="dt-readonly-form--change"> {this.changeText} </div>
          </div>
        </div>
      </div>
    </div>
  }
}